import Api from '@/api/api'
import configApi from '@/api/config/_api_config'

// LAB-001 : capacité signée « laboratoire:manage » (120 s) demandée à be_config, puis be_clinique avec l'en-tête.
const options = token => ({ med_access_scoped: true, timeout: 20000, headers: { 'X-Laboratoire-Access': token } })

export default {
    async access() {
        const response = await configApi().post('/laboratoire/access', {}, { timeout: 20000 })
        if (!response.data.success || !response.data.data || !response.data.data.access_token) throw new Error('Accès au laboratoire indisponible.')
        return response.data.data.access_token
    },
    referentiel(token) {
        return Api().get('/laboratoire/referentiel', options(token)).then(response => response.data)
    },
    suiviDemande(demande_id, token) {
        return Api().get('/laboratoire/demandes/' + demande_id + '/suivi', options(token)).then(response => response.data)
    },
    suiviBulletin(bulletin_id, token) {
        return Api().get('/laboratoire/bulletins/' + bulletin_id + '/suivi', options(token)).then(response => response.data)
    },
    // LAB-003 : réception au laboratoire et échantillons externes (action receptionner)
    receptionListe(data, token) {
        return Api().post('/laboratoire/reception/liste', data, options(token)).then(response => response.data)
    },
    receptionEnregistrer(data, token) {
        return Api().post('/laboratoire/reception/enregistrer', data, options(token)).then(response => response.data)
    },
    externeEnregistrer(data, token) {
        return Api().post('/laboratoire/externes/enregistrer', data, options(token)).then(response => response.data)
    },
    // LAB-004 : pièces jointes de résultat (lecture : consulter, écriture : analyser)
    documentsListe(demande_id, token) {
        return Api().get('/laboratoire/demandes/' + demande_id + '/documents', options(token)).then(response => response.data)
    },
    documentsAjouter(demande_id, form_data, token) {
        const multipart = Object.assign({}, options(token), { headers: { 'X-Laboratoire-Access': token, 'Content-Type': 'multipart/form-data' } })
        return Api().post('/laboratoire/demandes/' + demande_id + '/documents', form_data, multipart).then(response => response.data)
    },
    documentBlob(demande_id, document_id, token) {
        return Api().get('/laboratoire/demandes/' + demande_id + '/documents/' + document_id, Object.assign({}, options(token), { responseType: 'blob' })).then(response => response.data)
    },
    documentSupprimer(demande_id, document_id, token) {
        return Api().delete('/laboratoire/demandes/' + demande_id + '/documents/' + document_id, options(token)).then(response => response.data)
    },
    // LAB-005 : paillasse (action analyser)
    paillasseListe(data, token) {
        return Api().post('/laboratoire/paillasse/liste', data, options(token)).then(response => response.data)
    },
    debutAnalyse(demande_id, token) {
        return Api().post('/laboratoire/demandes/' + demande_id + '/debut-analyse', {}, options(token)).then(response => response.data)
    },
    // LAB-009 : fin de technique chronométrée (action analyser) et parcours tracé d'un bon (action consulter)
    finTechnique(demande_id, token) {
        return Api().post('/laboratoire/demandes/' + demande_id + '/fin-technique', {}, options(token)).then(response => response.data)
    },
    parcoursBulletin(bulletin_id, token) {
        return Api().get('/laboratoire/bulletins/' + bulletin_id + '/parcours', options(token)).then(response => response.data)
    },
    // LAB-006 : validation biologique (action valider) et compte rendu (action consulter)
    validationListe(data, token) {
        return Api().post('/laboratoire/validation/liste', data, options(token)).then(response => response.data)
    },
    valider(demande_id, data, token) {
        return Api().post('/laboratoire/demandes/' + demande_id + '/valider', data, options(token)).then(response => response.data)
    },
    retourSaisie(demande_id, data, token) {
        return Api().post('/laboratoire/demandes/' + demande_id + '/retour-saisie', data, options(token)).then(response => response.data)
    },
    retourTechnique(demande_id, data, token) {
        return Api().post('/laboratoire/demandes/' + demande_id + '/retour-technique', data, options(token)).then(response => response.data)
    },
    compteRendu(bulletin_id, token) {
        return Api().get('/laboratoire/bulletins/' + bulletin_id + '/compte-rendu', options(token)).then(response => response.data)
    },
    // LAB-007 : rectification après validation (action valider)
    rectifier(demande_id, data, token) {
        return Api().post('/laboratoire/demandes/' + demande_id + '/rectifier', data, options(token)).then(response => response.data)
    },
    // LAB-008 : indicateurs mensuels et registre des non-conformités (consulter), déclaration (analyser)
    indicateurs(mois, token) {
        return Api().get('/laboratoire/indicateurs', Object.assign({}, options(token), { params: { mois: mois } })).then(response => response.data)
    },
    nonConformitesListe(data, token) {
        return Api().post('/laboratoire/non-conformites/liste', data, options(token)).then(response => response.data)
    },
    nonConformiteDeclarer(data, token) {
        return Api().post('/laboratoire/non-conformites/declarer', data, options(token)).then(response => response.data)
    },
    nonConformiteCloturer(id, data, token) {
        return Api().post('/laboratoire/non-conformites/' + id + '/cloturer', data, options(token)).then(response => response.data)
    },
    // LAB-RES-001 : page « Résultats » médecins/infirmiers — suivi paginé du circuit (consulter)
    resultatsSuiviListe(data, token) {
        return Api().post('/laboratoire/resultats/suivi', data, options(token)).then(response => response.data)
    }
}
